import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import API from '../api/axiosInstance';

function AutoLoginRedirect() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const redeemed = useRef(false);

  useEffect(() => {
    const code = searchParams.get('code');

    if (!code) {
      navigate('/user-login', { replace: true });
      return;
    }

    if (redeemed.current) return;
    redeemed.current = true;

    API.post('/auth/redeem-auto-login', { code })
      .then((res) => {
        const { token, personId, username } = res.data;
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('role', 'user');
        sessionStorage.setItem('personId', personId || '');
        sessionStorage.setItem('username', username || '');
        sessionStorage.setItem('impersonating', '1');
        navigate('/user/dashboard', { replace: true });
      })
      .catch(() => {
        navigate('/user-login', { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        height: '100vh',
      }}
    >
      <Spinner animation="border" role="status" style={{ color: '#d9a128', width: 48, height: 48 }} />
      <p style={{ color: '#666', fontSize: '14px', margin: 0 }}>Signing in…</p>
    </div>
  );
}

export default AutoLoginRedirect;
